import React from 'react';

export const ChangeCard = ({ label, value, icon: Icon, bgColor, badgeColor, onClick, isClickable }) => {
  const hasValue = value && value !== 0;
  const canClick = isClickable && hasValue;

  return (
    <div 
      className={`${bgColor} rounded-lg p-4 flex items-center justify-between transition-all ${
        canClick ? 'cursor-pointer hover:shadow-md hover:scale-105' : ''
      }`}
      onClick={canClick ? onClick : undefined}
    >
      <div className="flex items-center gap-3">
        <span className={`${badgeColor} px-2.5 py-1 rounded-full text-sm font-medium`}>
          +{value}
        </span>
        <span className="text-sm font-medium text-gray-700">{label}</span>
      </div>
      <Icon className={`w-5 h-5 ${canClick ? 'text-gray-600' : 'text-gray-400'}`} />
      {canClick && (
        <div className="absolute bottom-1 right-2 text-xs text-gray-600 font-medium opacity-0 group-hover:opacity-100">
          →
        </div>
      )}
    </div>
  );
};